<mat-sidenav-container class="mg-shell" [class.mg-shell--recolhido]="asideRecolhido" autosize>
  <!-- `fixedInViewport` NÃO é opcional: sem ele o `.mat-drawer` é `position:
  absolute` dentro do contêiner e ROLA JUNTO com a página — a janela continua
  sendo a dona da rolagem (ver o comentário do `layout.component.scss`), então
  a sidebar sumiria ao rolar qualquer listagem. Com ele o Material aplica
  `position: fixed` (classe `.mat-sidenav-fixed`, medida em
  fesm2022/sidenav.mjs), o mesmo papel do `position: fixed` que o
  `aside.component.scss` declarava à mão. -->
  <mat-sidenav
    #gaveta
    class="mg-shell__gaveta"
    [mode]="modoGaveta"
    [opened]="(ehMobile$ | async) === false"
    fixedInViewport>
    <mg-aside
      [recolhido]="asideRecolhido"
      (alternarRecolhido)="alternarRecolhido()"
      (fechar)="fecharNoMobile()"></mg-aside>
  </mat-sidenav>

  <mat-sidenav-content class="mg-shell__coluna">
    <mg-header (abrirMenu)="gaveta.toggle()"></mg-header>

    @if (avisos.visible('maintenance')) {
    <aside class="mg-shell__manutencao" role="status" aria-label="Manutenção da aplicação">
      <span>Estamos atualizando a aplicação e podem ocorrer indisponibilidades temporárias. Encontrou um erro?</span>
      <a href="https://wa.me/553121802122" target="_blank" rel="noopener noreferrer">Fale no WhatsApp para atendimento prioritário.</a>
    </aside>
    }

    @if (ehTenant) {
      <mg-subscription-notice />
      @if (avisos.visible('incident')) {
        <app-support-incident-banner [incidentes]="incidentesAtivos()" />
      }
    }

    <mg-onboarding-contexto />
    <main class="mg-shell__pagina">
      <router-outlet></router-outlet>
    </main>

    @if (mostrarTopo) {
      <button type="button" matIconButton class="mg-shell__topo" aria-label="Voltar ao topo" (click)="subirAoTopo()">
        <svg viewBox="0 0 24 24" width="22" height="22" focusable="false" aria-hidden="true">
          <path fill="currentColor" d="M12 8l-6 6 1.4 1.4L12 10.8l4.6 4.6L18 14z" />
        </svg>
      </button>
    }
  </mat-sidenav-content>
</mat-sidenav-container>

@if (ehTenant) {
  <!--
    Achado da revisão (rodada 4): o painel "Ajuda e suporte" morava dentro
    do `<mat-toolbar>` de `mg-header` e ficava preso ao contexto de
    empilhamento sticky dela (z-index 95), atrás do cabeçalho sticky de
    qualquer `kt-table` (z-index 100).

    Achado da revisão (rodada 6, baixa): mesmo como irmão do cabeçalho, o
    hub continuava DENTRO de `<mat-sidenav-content>` — que é
    `.mat-drawer-content` do Material, `position: relative; z-index: 1`
    (fesm2022/sidenav.mjs), um contexto de empilhamento PRÓPRIO. O véu
    (`position: fixed`, z-index 105/110 aqui dentro) nunca escapava dele: um
    filho de `.mat-drawer-content` nunca pinta acima de `.mat-drawer`
    (a gaveta, z-index 3), porque é a COMPARAÇÃO ENTRE OS DOIS PAIS (z-index
    1 x 3) que decide, não o z-index interno do filho. Como irmão do
    `<mat-sidenav-container>` (fora do contexto do Material por completo), o
    véu/painel comparam certo contra a gaveta, com o menu aberto ou fechado.
  -->
  <app-support-hub />
}
